import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { LitElement, css, html } from "lit";
import { property, state } from "lit/decorators.js";
import { pdIcons } from "@progressive-development/pd-icon";
import "@progressive-development/pd-icon/pd-icon";
import "@progressive-development/pd-forms/pd-button";
import "@progressive-development/pd-forms/pd-input";
//#region src/pd-assistant-input-bar/PdAssistantInputBar.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
/**
* Input bar for assistant-style dialogs (search, chat).
*
* @tagname pd-assistant-input-bar
* @summary Text input with submit button for assistant dialogs.
*
* @event pd-assistant-submit - Fired on submit. Detail: `{ value: string }`.
*
* @cssprop --pd-assistant-input-bar-gap - Gap between input and button. Default: `8px`.
* @cssprop --pd-assistant-input-bar-padding - Bar padding. Default: `12px 20px 16px`.
*/
var PdAssistantInputBar = class extends LitElement {
	constructor(..._args) {
		super(..._args);
		this.placeholder = "Suchbegriff eingeben...";
		this.buttonIcon = pdIcons.ICON_SEARCH;
		this.buttonText = "Suchen";
		this.disabled = false;
		this._value = "";
	}
	static {
		this.styles = css`
    :host {
      display: block;
    }

    .input-row {
      display: flex;
      gap: var(--pd-assistant-input-bar-gap, 8px);
      padding: var(--pd-assistant-input-bar-padding, 12px 20px 16px);
      border-top: 1px solid var(--pd-default-light-col, #e0e0e0);
      align-items: center;
    }

    .input-row pd-input {
      flex: 1;
      --pd-input-field-width: 100%;
    }
  `;
	}
	render() {
		return html`
      <div class="input-row">
        <pd-input
          placeHolder="${this.placeholder}"
          .value="${this._value}"
          ?disabled="${this.disabled}"
          @pd-form-element-change="${this._onInputChange}"
          @enter-pressed="${this._onSubmit}"
        ></pd-input>
        <pd-button
          text="${this.buttonText}"
          primary
          ?disabled="${this.disabled || !this._value.trim()}"
          @button-clicked="${this._onSubmit}"
        ></pd-button>
      </div>
    `;
	}
	_onInputChange(e) {
		this._value = e.detail.value;
	}
	_onSubmit() {
		const value = this._value.trim();
		if (!value || this.disabled) return;
		this.dispatchEvent(new CustomEvent("pd-assistant-submit", {
			bubbles: true,
			composed: true,
			detail: { value }
		}));
	}
	/** Clear the input field. */
	clear() {
		this._value = "";
	}
};
__decorate([property({ type: String })], PdAssistantInputBar.prototype, "placeholder", void 0);
__decorate([property({ type: String })], PdAssistantInputBar.prototype, "buttonIcon", void 0);
__decorate([property({ type: String })], PdAssistantInputBar.prototype, "buttonText", void 0);
__decorate([property({ type: Boolean })], PdAssistantInputBar.prototype, "disabled", void 0);
__decorate([state()], PdAssistantInputBar.prototype, "_value", void 0);
//#endregion
export { PdAssistantInputBar };
